import { clsx as o } from "clsx";
import { twMerge as t } from "../node_modules/.pnpm/tailwind-merge@2.6.0/node_modules/tailwind-merge/dist/bundle-mjs.js";
function n(...r) {
  return t(o(r));
}
export {
  n as cn
};
//# sourceMappingURL=cn.js.map
